/**
 * Feature Products Handler
 * Handles feature products with device selection
 */

import { addToCart } from '../cart/api'
import { showDrawer } from '../cart/drawer'
import { storeFeatureCartData, getAvailableDevices } from './api'
import { initializeDeviceSelector } from './device-selector'

/**
 * Initialize feature products
 */
export function initializeFeatureProducts() {
  const featureAddToCartWrapper = document.querySelector('.pd__details--actions--feature')

  if (!featureAddToCartWrapper) return

  const productId = featureAddToCartWrapper.dataset.productId

  loadAvailableDevices(productId, featureAddToCartWrapper)
}

/**
 * Load available devices for user
 */
async function loadAvailableDevices(productId, wrapper) {
  try {
    const data = await getAvailableDevices(productId)

    if (data.success) {
      wrapper.innerHTML = data.data.html
      initializeDeviceSelector()
      attachFeatureFormHandler()
    }
  } catch (error) {
    console.error('Error loading devices:', error)
  }
}

/**
 * Attach submit handler to feature form
 */
function attachFeatureFormHandler() {
  const featureForm = document.querySelector('form[name="feature-add-to-cart"]')

  if (!featureForm) {
    console.error('Feature form not found in wrapper!')
    return
  }

  console.log('Attaching submit listener to feature form:', featureForm)

  featureForm.addEventListener('submit', handleFeatureAddToCart)
}

/**
 * Handle feature product add to cart
 */
async function handleFeatureAddToCart(event) {
  console.log('FEATURE ADD TO CART SUBMITTED!', event)
  event.preventDefault()

  const form = event.currentTarget
  const submitButton = form.querySelector('button[type="submit"]')

  if (!submitButton) return

  submitButton.classList.add('is-loading')
  submitButton.disabled = true

  const productId = form.querySelector('input[name="product_id"]')?.value
  const serialNumber = form.querySelector('input[name="serial_number"]')?.value
  const chipId = form.querySelector('input[name="chip_id"]')?.value

  if (!productId) {
    console.error('Product ID missing')
    clearLoadingState(submitButton)
    return
  }

  try {
    // Step 1: Add product to cart using Store API
    const cartData = await addToCart(productId, 1)
    console.log('Store API response:', cartData)

    // Find the cart item key by matching the product we just added. Do NOT fall back to the
    // "last item" in the cart: if the add did not land (e.g. validation blocked it), that would
    // target an unrelated product already in the cart and attach the serial/chip to the WRONG line.
    const addedItem = cartData.items?.find(item => item.id === parseInt(productId, 10))
    const cartItemKey = addedItem?.key ?? null

    console.log('Cart item key:', cartItemKey)

    // Step 2: Store device metadata (serial number, chip ID)
    if (serialNumber && chipId && cartItemKey) {
      await storeFeatureCartData(cartItemKey, serialNumber, chipId)
    } else {
      // Feature product is not in the returned cart, or device data is missing — do NOT stamp
      // metadata onto some other cart item.
      console.error('Feature product was not added to the cart, or device data is missing:', { productId, serialNumber, chipId, cartItemKey })
    }

    clearLoadingState(submitButton)

    // Step 3: Show cart drawer
    await showDrawer()

  } catch (error) {
    console.error('Error adding feature to cart:', error)
    clearLoadingState(submitButton)
  }
}

/**
 * Clear button loading state
 */
function clearLoadingState(button) {
  button.classList.remove('is-loading')
  button.disabled = false
}
